// extracted by mini-css-extract-plugin
export default {"SinConfigurarWrapper":"SinConfigurar_SinConfigurarWrapper__sE1dF","SinConfigurarContainer":"SinConfigurar_SinConfigurarContainer__3xj-y","TextoInfo":"SinConfigurar_TextoInfo__PMFZz"};